import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context'
import { Link } from 'react-router-dom';
// import { Editor } from 'react-draft-wysiwyg';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import { EditorState } from 'draft-js';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
import draftToHtml from 'draftjs-to-html';
import { history } from '../../_helpers';


function ReportSingle() {
  const [report, setReport] = useState()
  const [state, actions] = useContext(UserContext);
  
  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}

  // const [title, setTitle] = useState()
  // const [contentCom, setContentCom] = useState()
  // const [tempComment, setTempComment] = useState()
  // const [comments, setComments] = useState()

  // const editorToHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
  let current_id = history.location.pathname.split('/')[3]
  const [editorToHtml, setEditorToHtml] = useState(EditorState.createEmpty())
  


  useEffect(()=>{
    async function fetchReportGet(){
       fetch(state.awslink + "/api/report/?id=" + current_id, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.content))) 

        setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
        setReport(json)
      }
      )
    }

    // async function fetchCommentGet(){
    //    fetch(state.awslink + "/api/comment/?id=" + current_id, {
    //   method: 'GET',
    //   headers: header,
    //   })
    //   .then(response => response.json())
    //   .then(json=>{
    //     console.log(json)
        
    //     // setComments(oldArray => [...oldArray, json])
    //     setComments(json)
        
    //   }
    //   )
    // }
    
    fetchReportGet();
    // fetchCommentGet();
  }, [])

  // console.log(comments)
  // console.log(draftToHtml(convertToRaw(editorToHtml.getCurrentContent())))
  console.log(report)
  console.log(email)
  return(
    <Wrapper>
      <MidWrapper>
        {report?
          <>
            <div>
              {report.title}
            </div>
            
            <div>
              {report.created.split('T')[0]}
            </div>

            {report.user.email === email ?
              <Link to={'/recruiter/report/edit/' + report.id}>수정하기</Link>
            :null}

            <IntroduceContent dangerouslySetInnerHTML={{__html: editorToHtml}}/>
          </>
        :null  }
        
        {/* {tempComment?
          <>
            <div>{email}</div>
            <div>{tempComment}</div>
            <div>방금</div>
          </>
        :null}

        {comments?
          comments.length?
            comments.map((item, index)=>{
              return(
                <>
                  <div>{item.user.email}</div>
                  <div>{item.content}</div>
                  <div>{item.created.split('T')[0]}</div>
                </>
              )
            })
          :null
        :null} */}
        

        {/* <div>
          <div><input onChange={(e)=> setContentCom(e.target.value)}/></div>
          <div><button onClick={()=>{fetchCommentPost(); setTempComment(contentCom)}}>SEND</button></div>
        </div> */}

      </MidWrapper>
    </Wrapper>   
  )
}

export default ReportSingle;


const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 135px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`


const MidWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 980px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: column;
`

// 생략..
// 변환시켜준 editorState 값을 넣기 위한 div 태그 css 
const IntroduceContent = styled.div`
  position: relative;
  border: 0.0625rem solid #d7e2eb;
  border-radius: 0.75rem;
  overflow: hidden;
  padding: 1.5rem;
  width: 50%;
  margin: 0 auto;
  margin-bottom: 4rem;
`;


// const Card = styled.div`
//   /* width: 25%; */
//   width: 221px;
//   /* max-width: 240px; */
//   height: 220px;
//   border: rgba(0,0,0,0.5) 2px solid;
//   border-radius: 7px;
//   margin: 10px;

//   display: flex;
//   /* flex-wrap: wrap; */
//   /* flex-grow: 4; */
//   justify-content: flex-start;
  
//   align-items: flex-start;
//   flex-direction: column;
//   position: relative;

  
  
//   :nth-child(5){
//     /* background-color:green; */
//     break-after: always;
//   }
//   >a{
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     /* z-index:2; */
//   }
// `